import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type InstagramProps = React.HTMLAttributes<HTMLDivElement> & {};

export const Instagram: React.FC<InstagramProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/svg/instagram.svg"} alt="" />
    </div>
  );
};